import { useFormInput } from 'js/lib/form'

const textInputs = document.querySelectorAll('.js-c-form-input--text')
textInputs.forEach(initialize)

function initialize(input) {
  const { onDependentChange } = useFormInput(input)
  onDependentChange(dependency => handleDependentChange(input, dependency))
}

function handleDependentChange(input, dependency) {
  switch (dependency.behaviour.type) {
    case 'value':
      updateValue(input, dependency.behaviour.getValue())
      break
  }
}

function updateValue(input, value) {
  input.value = String(value)
  input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }))
}
